import { TinkLinkUrlParameter } from '@tink/config/src/TinkLinkUrlParameter';
import { InteractionEvent, PageView } from '../../../../../../models/analytics';
import { getParameter } from '../../../../../../utilities/urlParametersValidator';

export const getAutoRedirectMobileQueryParamAnalytic = (): InteractionEvent | null => {
  // We get the parameter unvalidated since we want to discriminate between 'false' and 'undefined'.
  const autoRedirectMobileQueryParam = getParameter(TinkLinkUrlParameter.AUTO_REDIRECT_MOBILE);

  // Don't send analytics if the parameter is not present.
  if (autoRedirectMobileQueryParam === undefined) return null;

  return {
    view: PageView.AWAITING_THIRD_PARTY_AUTHENTICATION_SCREEN,
    label: 'AUTO_REDIRECT_MOBILE',
    action: autoRedirectMobileQueryParam === 'true' ? 'true' : 'false',
  };
};
